import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import i18next from "i18next";
import "../HomePage.scss";

export default function FooterSection() {
  const [searchParams, setSearchParams] = useSearchParams();
  const ver = searchParams.get("ver") || "1";
  const BROWSERLANGUAGE = i18next.language;

  const { t } = useTranslation(["page"]);

  return (
    <div className="FooterSection">
      <div className="section-content">
        <div className="flex-column">
          <div className="flex-row">
            <div className="container-1">
              Copyright © 2023 Apeiro Corp
              <br />
              All rights reserved.
              <br />
              <br />
              <br />
            </div>
            <div className="container-2">
              <div className="download-images flex-row">
                <a href="https://apps.apple.com/us/app/autolang/id6449036780">
                  <img
                    className="download-image"
                    src="images/newhome/download_apple.webp"
                    alt="appstore link image"
                    loading="lazy"
                  ></img>
                </a>

                <a href="https://play.google.com/store/apps/details?id=com.apeiro.langgpt&hl=en-KR">
                  <img
                    className="download-image"
                    src="images/newhome/download_google.webp"
                    alt="playstore link image"
                    loading="lazy"
                  ></img>
                </a>
              </div>
            </div>
          </div>

          <div className="flex-row privacy">
            <div className="container-1 email">
              Reach us at support@apeirocorp.com
            </div>
            <div className="container-2">
              <a
                className="a-tag"
                href="https://www.autolang.co/legal/eng/privacy.html"
              >
                Privacy Policy
              </a>
              <a href="https://www.autolang.co/legal/eng/terms.html">
                Terms of Service
              </a>
              <br />
            </div>
          </div>

          <div className="hello"></div>
        </div>
      </div>
    </div>
  );
}
